(() => {
  const root = document.querySelector('#padel-mini-game');
  if (!root) return;

  const duration = Number(root.dataset.duration || 30);
  const reward10 = root.dataset.reward10 || '';
  const reward20 = root.dataset.reward20 || '';
  const redirectUrl = root.dataset.redirectUrl || '/collections/all';
  const racketAsset = root.dataset.racketImage || '';
  const ballAsset = root.dataset.ballImage || '';

  const startScreen = root.querySelector('[data-screen="start"]');
  const playScreen = root.querySelector('[data-screen="play"]');
  const endScreen = root.querySelector('[data-screen="end"]');

  const startBtn = root.querySelector('.padel-game__start-btn');
  const retryBtn = root.querySelector('.padel-game__retry-btn');
  const claimBtn = root.querySelector('[data-claim-btn]');
  const rewardMessage = root.querySelector('[data-reward-message]');
  const timeEl = root.querySelector('[data-time]');
  const finalScoreEl = root.querySelector('[data-final-score]');

  const playerScoreEl = root.querySelector('[data-player-score]');
  const aiScoreEl = root.querySelector('[data-ai-score]');
  const arena = root.querySelector('[data-arena]');
  const playerRacket = root.querySelector('[data-player-racket]');
  const aiRacket = root.querySelector('[data-ai-racket]');
  const ballEl = root.querySelector('[data-ball]');

  let playerScore = 0;
  let aiScore = 0;
  let timeLeft = duration;
  let gameRunning = false;
  let animationFrame = null;
  let timerInterval = null;

  let playerX = 0;
  let playerTargetX = 0;
  let aiX = 0;
  let aiTargetX = 0;

  let ball = {
    x: 100,
    y: 100,
    vx: 5,
    vy: 7,
    size: 28
  };

  if (racketAsset) {
    playerRacket.style.backgroundImage = `url("${racketAsset}")`;
    aiRacket.style.backgroundImage = `url("${racketAsset}")`;
  }

  if (ballAsset) {
    ballEl.style.backgroundImage = `url("${ballAsset}")`;
  }

  function showScreen(screen) {
    [startScreen, playScreen, endScreen].forEach((el) => el.classList.add('hidden'));
    screen.classList.remove('hidden');
  }

  function getBallSize() {
    if (window.innerWidth < 480) return 22;
    if (window.innerWidth < 768) return 26;
    return 30;
  }

  function updateHud() {
    playerScoreEl.textContent = String(playerScore);
    aiScoreEl.textContent = String(aiScore);
    timeEl.textContent = String(timeLeft);
  }

  function placeRackets() {
    const arenaWidth = arena.clientWidth;
    const playerWidth = playerRacket.offsetWidth;
    const aiWidth = aiRacket.offsetWidth;

    playerX = (arenaWidth - playerWidth) / 2;
    playerTargetX = playerX;
    playerRacket.style.left = `${playerX}px`;

    aiX = (arenaWidth - aiWidth) / 2;
    aiTargetX = aiX;
    aiRacket.style.left = `${aiX}px`;
  }

  function resetBall(direction = 1) {
    ball.size = getBallSize();
    ball.x = arena.clientWidth / 2 - ball.size / 2;
    ball.y = arena.clientHeight / 2 - ball.size / 2;

    const horizontal = Math.random() > 0.5 ? 5 : -5;
    ball.vx = horizontal;
    ball.vy = direction * 7;

    ballEl.style.width = `${ball.size}px`;
    ballEl.style.height = `${ball.size}px`;

    renderBall();
  }

  function renderBall() {
    ballEl.style.left = `${ball.x}px`;
    ballEl.style.top = `${ball.y}px`;
  }

  function resetGame() {
    playerScore = 0;
    aiScore = 0;
    timeLeft = duration;
    gameRunning = false;

    claimBtn.classList.add('hidden');
    claimBtn.removeAttribute('href');
    rewardMessage.textContent = '';
    finalScoreEl.textContent = '0 - 0';

    updateHud();
    placeRackets();
    resetBall(Math.random() > 0.5 ? 1 : -1);
  }

  function rectsOverlap(a, b) {
    return !(
      a.right < b.left ||
      a.left > b.right ||
      a.bottom < b.top ||
      a.top > b.bottom
    );
  }

  function updatePlayer() {
    const maxX = arena.clientWidth - playerRacket.offsetWidth;
    playerTargetX = Math.max(0, Math.min(playerTargetX, maxX));
    playerX += (playerTargetX - playerX) * 0.28;
    playerRacket.style.left = `${playerX}px`;
  }

  function updateAI() {
    const aiWidth = aiRacket.offsetWidth;
    const desiredX = ball.x + ball.size / 2 - aiWidth / 2;
    const maxX = arena.clientWidth - aiWidth;

    aiTargetX += (desiredX - aiTargetX) * 0.22;
    aiTargetX = Math.max(0, Math.min(aiTargetX, maxX));

    aiX += (aiTargetX - aiX) * 0.38;
    aiRacket.style.left = `${aiX}px`;
  }

  function bounceFromRacket(racketEl, isPlayer) {
    const racketRect = racketEl.getBoundingClientRect();
    const ballRect = ballEl.getBoundingClientRect();

    if (!rectsOverlap(ballRect, racketRect)) return false;

    if (isPlayer && ball.vy <= 0) return false;
    if (!isPlayer && ball.vy >= 0) return false;

    const racketCenter = racketRect.left + racketRect.width / 2;
    const ballCenter = ballRect.left + ballRect.width / 2;
    const offset = (ballCenter - racketCenter) / (racketRect.width / 2);

    if (isPlayer) {
      ball.vx = offset * 8;
      ball.vy = -Math.abs(ball.vy) * 1.04;
      ball.y = arena.clientHeight - racketEl.offsetHeight - ball.size - 18;
    } else {
      ball.vx = offset * 10;
      ball.vy = Math.abs(ball.vy) * 1.06;
      ball.y = racketEl.offsetHeight + 18;
    }

    return true;
  }

  function updateBall() {
    ball.x += ball.vx;
    ball.y += ball.vy;

    if (ball.x <= 0) {
      ball.x = 0;
      ball.vx *= -1;
    }

    if (ball.x + ball.size >= arena.clientWidth) {
      ball.x = arena.clientWidth - ball.size;
      ball.vx *= -1;
    }

    bounceFromRacket(playerRacket, true);
    bounceFromRacket(aiRacket, false);

    if (ball.y > arena.clientHeight) {
      aiScore += 1;
      updateHud();
      resetBall(-1);
      return;
    }

    if (ball.y + ball.size < 0) {
      playerScore += 1;
      updateHud();
      resetBall(1);
      return;
    }

    renderBall();
  }

  function loop() {
    if (!gameRunning) return;
    updatePlayer();
    updateAI();
    updateBall();
    animationFrame = requestAnimationFrame(loop);
  }

  function getRewardCode() {
    const diff = playerScore - aiScore;

    if (playerScore > aiScore && diff >= 2) return reward20;
    if (playerScore > aiScore) return reward10;
    return '';
  }

  function endGame() {
    gameRunning = false;
    clearInterval(timerInterval);
    cancelAnimationFrame(animationFrame);

    finalScoreEl.textContent = `${playerScore} - ${aiScore}`;

    const rewardCode = getRewardCode();

    if (playerScore > aiScore && playerScore - aiScore >= 2) {
      rewardMessage.textContent = 'Amazing! You beat the AI by 2+ points and unlocked 20% OFF.';
    } else if (playerScore > aiScore) {
      rewardMessage.textContent = 'Great job! You beat the AI and unlocked 10% OFF.';
    } else if (playerScore === aiScore) {
      rewardMessage.textContent = 'It is a draw. Try again and beat the AI to unlock your reward.';
    } else {
      rewardMessage.textContent = 'The AI won this round. Try again and beat it to unlock a reward.';
    }

    if (rewardCode) {
      claimBtn.classList.remove('hidden');
      claimBtn.href = `/discount/${encodeURIComponent(rewardCode)}?redirect=${encodeURIComponent(redirectUrl)}`;
    }

    showScreen(endScreen);
  }

  function startGame() {
    clearInterval(timerInterval);
    cancelAnimationFrame(animationFrame);

    resetGame();
    showScreen(playScreen);
    gameRunning = true;

    timerInterval = setInterval(() => {
      timeLeft -= 1;
      updateHud();

      if (timeLeft <= 0) {
        endGame();
      }
    }, 1000);

    loop();
  }

  function setPlayerTarget(clientX) {
    const rect = arena.getBoundingClientRect();
    const racketWidth = playerRacket.offsetWidth;

    let nextX = clientX - rect.left - racketWidth / 2;
    nextX = Math.max(0, Math.min(nextX, arena.clientWidth - racketWidth));
    playerTargetX = nextX;
  }

  arena.addEventListener('pointerdown', (e) => {
    if (!gameRunning) return;
    setPlayerTarget(e.clientX);
  });

  arena.addEventListener('pointermove', (e) => {
    if (!gameRunning) return;
    setPlayerTarget(e.clientX);
  });

  window.addEventListener('resize', () => {
    placeRackets();
    resetBall(Math.random() > 0.5 ? 1 : -1);
  });

  startBtn.addEventListener('click', startGame);
  retryBtn.addEventListener('click', startGame);

  showScreen(startScreen);
  resetGame();
})();